import type { ReactNode } from "react";

/** Layout lista (sinistra) + dettaglio (destra), riusato da Chat/Email/Telefono. */
export function ConvoSplitView({
  lista,
  dettaglio,
}: {
  lista: ReactNode;
  dettaglio: ReactNode;
}) {
  return (
    <div className="grid min-h-[520px] grid-cols-1 overflow-hidden rounded-xl border bg-card md:grid-cols-[320px_1fr]">
      <div className="max-h-[640px] overflow-y-auto border-b bg-muted/20 md:border-b-0 md:border-r">
        {lista}
      </div>
      <div className="flex min-w-0 flex-col">{dettaglio}</div>
    </div>
  );
}
